import React, { useState } from "react";
import styled from "styled-components";
import SlotGameCardNew from "./SlotGameCardNew";
import { CircularProgress, Progress } from "@chakra-ui/react";
import useSlotGames from "hooks/slots/useSlotGames";

type Props = {
  provider?: string;
  sort?: string;
};
const step = 9;
const EAGER_CARDS_COUNT = 8;
function SlotsSection({ provider, sort }: Props) {
  const [take, setTake] = useState(27);

  const { data, isFetching } = useSlotGames({
    take,
    provider,
    sort,
  });

  const { data: slots = [], total = 0 } = data ?? {};

  const onLoadMore = () => {
    const stepC = step * 4;
    if (take + stepC >= total) {
      setTake(total);
    } else {
      setTake((t) => t + stepC);
    }
  };

  const persents = ((take / total) * 100).toFixed(2);

  return (
    <SlotsWrapper>
      <SlotGrid>
        {slots.map((slot, index) => {
          return (
            <SlotGameCardNew
              codeSlug={slot.codeSlug}
              key={slot.code}
              code={slot.code}
              imageCode={slot.imageCode}
              imageBgUrl={slot.imageBgUrl}
              imageIconUrl={slot.imageIconUrl}
              imageTextUrl={slot.imageTextUrl}
              name={slot.name}
              provider={slot.provider}
              isFavorite={slot.isFavorite}
              eager={index < EAGER_CARDS_COUNT}
            />
          );
        })}
      </SlotGrid>
      <SlotsFooter>
        {isFetching && (
          <>
            <CircularProgress isIndeterminate />
          </>
        )}

        <>
          <Progress
            width={"100%"}
            value={+persents}
            borderRadius={10}
            background={"rgba(171, 186, 219, 0.05)"}
            height={2}
            borderColor={"transparent"}
          />
          {!isFetching && <p>{`Showing ${slots.length} out of ${total} games.`}</p>}

          {total > take && <LoadMoreButton onClick={() => onLoadMore()}>Load More</LoadMoreButton>}
        </>
      </SlotsFooter>
    </SlotsWrapper>
  );
}

const LoadMoreButton = styled.button`
  font-family: var(--font-family-golos);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid var(--dark-foggy-night-50, rgba(29, 34, 52, 0.5));
  background: var(--Dark-Midnight, #141722);
  color: var(--pure-sky-100, #00b2ff);
  transition: 0.2s all ease-in-out;

  &:hover {
    border-color: #141722;
    color: #141722;
    background: #00b2ff;
  }

  &:disabled {
    pointer-events: none;
  }
`;

const SlotsFooter = styled.div`
  width: 100%;
  max-width: 280px;
  margin-top: 4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  text-align: center;
  font-family: var(--font-family-golos);
  font-size: 14px;
  font-style: normal;
  color: var(--clouds-100, #abbadb);
`;
const SlotsWrapper = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SlotGrid = styled.div`
  width: 100%;
  display: grid;
  width: 100%;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 16px;
  position: relative;
`;

export default SlotsSection;
